export default __webpack_public_path__ + "static/media/logo-white.8bd33416.svg";